import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { parseDate } from '@internationalized/date';
import { selectDateRange, selectSelectedPlant, selectPhase } from '@pages/reporting-pages/undelivered-orders/store/selectors';
import { setDateRange, setSelectedPlant, setPhase } from '@pages/reporting-pages/undelivered-orders/store/slice';
import { useGetPlantsListQuery } from '@api/list-data/api';
import { DateRangePicker } from 'components/date-picker/DateRangePicker';
import { Select } from 'components/select/Select';
import { ComboBox } from 'components/select/ComboBox';
import { ListBoxItem } from 'react-aria-components';
import { DateRange } from '@project-types/DateRange';
import { UndeliveredPhase } from '@api/order-reporting/types/UndeliveredParams';



const ParamsToolbar = () => {

	const dateRange = useSelector(selectDateRange);
	const selectedPlant = useSelector(selectSelectedPlant);
	const phase = useSelector(selectPhase);

	const dispatch = useDispatch();
	const updateDateRange = (dateRange: DateRange) => dispatch(setDateRange(dateRange));
	const updateSelectedPlant = (value: string | null) => dispatch(setSelectedPlant(value));
	const updatePhase = (value: string | null) => dispatch(setPhase(value));

	const { data, isLoading, isFetching, isError } = useGetPlantsListQuery({ userId: 'any' });

	return (
		<div className='reporting-params-toolbar undelivered-orders-toolbar'>
			
			<DateRangePicker
				label='Od - Do'
				isRequired={true}
				value={
					dateRange
					? { start: parseDate(dateRange.from), end: parseDate(dateRange.to) }
					: null
				}
				onChange={(rangeValue) => {
					if (rangeValue) {
						updateDateRange({
							from: rangeValue.start.toString(),
							to: rangeValue.end.toString(),
						});
					}
				}}
			/>

			<Select
				label='Fáze zrušení'
				selectedKey={phase ? phase : ''}
				items={[
					{ id: '', text: 'Všechny' },
					{ id: UndeliveredPhase.execution, text: 'Exekuce' },
					{ id: UndeliveredPhase.plan, text: 'Plán' }
				]}
				onSelectionChange={selected => {
					if (typeof selected === 'string') {
						updatePhase(selected ? selected : null)
					}
				}}
			>
				{(item) => <ListBoxItem id={item.id}>{item.text}</ListBoxItem>}
			</Select>

			<ComboBox
				label='Depo'
				defaultItems={data
					? [
						{ id: '', text: 'Všechna depa' },
						...data.toSorted((a,b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0))
					]
					: []
				}
				isDisabled={isLoading || isFetching}
				errorMessage='Problém při načítání dat'
				isInvalid={isError}
				selectedKey={selectedPlant ? selectedPlant : ''}
				onSelectionChange={selected => {
					if (typeof selected === 'string') {
						updateSelectedPlant(selected ? selected : null);
					}
				}}
			>
				{(item) => <ListBoxItem id={item.id}>{item.text}</ListBoxItem>}
			</ComboBox>

		</div>
	)
};

export default memo(ParamsToolbar);